import React from 'react';
import PropTypes from 'prop-types';
import { connectLean } from 'lean-redux';
import {
  AssignedIconWithTooltip,
  WatchedIconWithTooltip,
} from 'chameleon/ui-stack/ui/assessments/icons-with-tooltip';
import './styles.scss';

const VideoItem = ({
  id,
  title,
  description,
  thumbnailUrl,
  progressPercentage,
  isAssigned,
  isStudent,
  isTeacher,
  hasWatchedVideo,
  width,
}) => (
  <div
    className="ft-video-carousel-item"
    title={description ? `${title}: ${description}` : title}
    aria-label={`${title}${description && `, ${description}`}, ${progressPercentage.toFixed(2)}% progress`}
  >
    <div className="ft-video-header">
      <div className="flex-vertical-align">
        {(isStudent || isTeacher) && isAssigned && (
          <AssignedIconWithTooltip
            target={`video-assigned-${id}`}
            className="mr-2 text-gray-800"
          />
        )}
        <div
          className="ft-video-title ellipsis"
          style={{ width: `${width - 64}px` }}
        >
          {title}
        </div>
      </div>
      <div className="flex-vertical-align">
        {isStudent && hasWatchedVideo && (
          <WatchedIconWithTooltip
            target={`video-watched-${id}`}
            className="text-gray-800"
          />
        )}
      </div>
    </div>
    <div className="ft-video-container">
      <img src={thumbnailUrl} alt="AP Daily Video thumbnail" />
      {(isStudent || isTeacher) && (
        <div
          className="ft-video-progress-container"
          aria-label={`${progressPercentage.toFixed(2)}% progress`}
        >
          <svg
            className="hidden-element-accessibility"
            height="1px"
            width="1px"
          />
          <div
            className="ft-video-progress"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      )}
    </div>
  </div>
);

VideoItem.displayName = 'VideoItem';

VideoItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string.isRequired,
  isAssigned: PropTypes.bool,
  isTeacher: PropTypes.bool,
  isStudent: PropTypes.bool,
  studentClasses: PropTypes.array,
  hasWatchedVideo: PropTypes.bool,
  width: PropTypes.number.isRequired,
  filteredClasses: PropTypes.array,
};

VideoItem.defaultProps = {
  isAssigned: false,
  isTeacher: false,
  isStudent: false,
  studentClasses: [],
  hasWatchedVideo: false,
  filteredClasses: [],
};

export default connectLean({
  mapState({ savedClasses, withWatchedVideo: hasWatchedVideo }, ownProps) {
    const { isTeacher, isStudent, studentClasses, filteredClasses } = ownProps;
    const savedClassesList = savedClasses || [];
    const studentClassesIds = studentClasses.map((section) =>
      Number.parseInt(section.id, 10),
    );
    const isStudentAssigned =
      isStudent &&
      savedClassesList.some((sectionId) =>
        studentClassesIds.includes(sectionId),
      );

    let isTeacherAssigned = false;
    if (isTeacher) {
      if (filteredClasses && filteredClasses.length > 0) {
        const filteredClassIds = filteredClasses.map((section) =>
          Number.parseInt(section.id, 10),
        );
        isTeacherAssigned = savedClassesList.some((sectionId) =>
          filteredClassIds.includes(sectionId),
        );
      } else {
        isTeacherAssigned = savedClassesList.length > 0;
      }
    }

    return {
      isAssigned: isTeacherAssigned || isStudentAssigned,
      hasWatchedVideo,
    };
  },
})(VideoItem);
